module.exports = {
  "dynamic": {
    more: "查看更多",
    xlzx: "心理资讯",
    xlhd: "心理活动",
    xlrx: "心理热线"
  },
}


// WEBPACK FOOTER //
// ./src/i18n/dynamic/zh-CN.js